<template>
  <div>
    <v-row class="px-1 py-1 mb-1  ma-1">
      <v-col cols="12" md="2" lg="2" sm="4">
        <v-btn
          v-if="tab == 1"
          color="blue"
          class="white--text"
          block
          @click="printShortListedData()"
          >Print <v-icon medium class="mx-1">mdi-printer</v-icon></v-btn
        ></v-col
      >
    </v-row>

    <v-card flat outlined class="px-4 py-3 mb-4 rounded-lg ma-3">
      <v-row align="center" no-gutters class="flex-wrap">
        <!-- Tabs -->
        <v-col cols="12" md="auto" class="mb-2 mb-md-0">
          <v-tabs
            v-model="activeTab"
            color="#519043"
            slider-color="#519043"
            align-tabs="left"
          >
            <v-tab v-for="tab in tabList" :key="tab.id" @click="changeTab(tab)">
              {{ tab.name }}
            </v-tab>
          </v-tabs>
        </v-col>

        <v-spacer class="d-none d-md-flex" />

        <!-- Date range filter -->
        <v-col
          cols="12"
          md="auto"
          v-if="tab == 1"
          class="d-flex align-center mb-2 mb-md-0"
        >
          <v-chip
            v-if="date_from && date_to"
            color="#519043"
            text-color="white"
            close
            close-icon="mdi-close"
            class="mr-2"
            @click:close="clearDateFilter"
          >
            <v-icon left small>mdi-calendar-range</v-icon>
            {{ formatDate(date_from) }} – {{ formatDate(date_to) }}
          </v-chip>
          <!-- <v-chip
            v-if="date_from && date_to"
            color="#519043"
            text-color="white"
            class="mr-2"
          >
            <v-icon left small>mdi-calendar-range</v-icon>
            {{ formatDate(date_from) }} – {{ formatDate(date_to) }}
          </v-chip> -->

          <v-btn
            @click="filterDialog = true"
            color="#519043"
            outlined
            medium
            class="rounded-lg mx-2"
          >
            <v-icon left small>mdi-filter-variant</v-icon>
            Filter
          </v-btn>
        </v-col>

        <!-- Search -->
        <v-col cols="12" md="3" class="mt-2 mt-md-0">
          <v-text-field
            v-model="search"
            outlined
            dense
            hide-details
            clearable
            single-line
            label="Search"
            prepend-inner-icon="mdi-magnify"
            color="#239FAB"
            class="rounded-lg"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="ma-5 dt-container" elevation="0" outlined>
      <v-data-table
        :headers="tab == 1 ? headers1 : headers"
        :items="data"
        :items-per-page="10"
        :search="search"
        :options.sync="options"
        :loading="loading"
        @pagination="pagination"
        hide-default-footer
      >
        <template v-slot:[`item.fullname`]="{ item }">
          {{ toTitleCase(item.fullname) }}
        </template>

        <template v-slot:[`item.positionsApplied`]="{ item }">
          <div class="positions-list">
            <v-chip
              v-for="(position, index) in item.positionsApplied"
              :key="index"
              small
              label
              outlined
              color="#519043"
              class="position-chip"
            >
              <v-icon left small>mdi-briefcase-variant</v-icon>
              {{ position.position }}
              <span class="position-date">{{
                formatDate(position.created)
              }}</span>
            </v-chip>
          </div>
        </template>
        <template v-slot:[`item.training`]="{ item }">
          <div
            class="text-caption "
            v-if="hasHtmlTags(item.training) === false"
          >
            {{ item.training }}
          </div>
          <div v-else class="text-caption" v-html="item.training"></div>
        </template>
        <template v-slot:[`item.ja_birth`]="{ item }">{{
          formatDate(item.ja_birth)
        }}</template>
        <template v-slot:[`item.age`]="{ item }">{{
          calculateAge(item.ja_birth)
        }}</template>
        <template v-slot:[`item.experience`]="{ item }">
          <div
            class="text-caption"
            v-if="hasHtmlTags(item.experience) === false"
          >
            {{ item.experience }}
          </div>
          <div v-else class="text-caption" v-html="item.experience"></div>
        </template>

        <template v-slot:[`item.education`]="{ item }">
          <div
            class="text-caption"
            v-if="item.education != null && item.education != ''"
          >
            {{ item.education }}
          </div>
          <div
            class="text-caption"
            v-else
            v-html="item.job_posting_content"
          ></div>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <div class="text-no-wrap">
            <v-btn
              v-if="tab == 2"
              x-small
              color="orange"
              class="mx-1 my-2"
              outlined
              block
              @click="viewApplicant(item)"
            >
              <v-icon size="14">mdi-eye-outline</v-icon> Applicant
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>
    <v-row class="mb-2 mx-5" align="center">
      <v-col cols="auto" class="mr-auto text-truncate flex-items" no-gutters>
        <span class="px-2">Show</span>
        <span>
          <v-select
            dense
            outlined
            color="#519043"
            hide-details
            :value="options.itemsPerPage"
            style="max-width: 90px"
            class="rounded-lg"
            @change="options.itemsPerPage = parseInt($event, 10)"
            :items="perPageChoices"
          >
          </v-select>
        </span>
        <span class="px-2"> Entries </span>
      </v-col>

      <v-col cols="auto" class="mr-auto text-truncate" no-gutters>
        Showing {{ paginationData.pageStart + 1 }} to
        {{ paginationData.pageStop }} of
        {{ paginationData.itemsLength }} entries
      </v-col>
      <v-col cols="auto">
        <v-pagination
          v-model="options.page"
          class="rounded-lg"
          :total-visible="7"
          color="#519043"
          :length="paginationData.pageCount"
        >
        </v-pagination>
      </v-col>
    </v-row>

    <ApplicantOfJobDialog :data="applicantData" :action="action" />

    <v-dialog v-model="confirmDialog" persistent max-width="350">
      <v-card color="white">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-h6 mb-1">WARNING!</div>
          <div class="text-body-1 mb-1">
            <p style="text-align: justify">
              <v-icon class="mt-n2" color="white">mdi-alert</v-icon> &nbsp; Are
              you sure you want to delete this information?<br /><br />
              Please note that
              <b>this action is irreversible.</b>
            </p>
          </div>
        </div>

        <!-- <v-card-title class="text-h5">
              Are you sure you want to proceed?
            </v-card-title> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="confirmDialog = false">
            Close
          </v-btn>
          <v-btn color="#147452" class="white--text" @click="deleteItem()">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="filterDialog" persistent max-width="650">
      <v-card color="white">
        <v-card-title class="text-h6 mb-1 dialog-header" dark
          >Filter by Date</v-card-title
        >
        <v-card-text class="text-body-1 mb-1">
          <span style="text-align: justify">
            Please select the date range to filter the applicants.
          </span>
          <div class="pa-4 #3a3b3a--text">
            <div class="d-flex align-center">
              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                :return-value.sync="date_from"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date_from"
                    label="Date From"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    outlined
                    dense
                    hide-details
                    clearable
                    class="rounded-lg"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date_from"
                  no-title
                  scrollable
                  color="#519043"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="#519043" @click="menu1 = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    text
                    color="#519043"
                    @click="$refs.menu1.save(date_from)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>

              <span class="mx-2 text--disabled">–</span>

              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="date_to"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date_to"
                    label="Date To"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    outlined
                    dense
                    hide-details
                    clearable
                    class="rounded-lg"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date_to"
                  no-title
                  scrollable
                  color="#519043"
                  :min="date_from"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="#519043" @click="menu = false"
                    >Cancel</v-btn
                  >
                  <v-btn text color="#519043" @click="$refs.menu.save(date_to)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </div>
          </div>
        </v-card-text>

        <!-- <v-card-title class="text-h5">
              Are you sure you want to proceed?
            </v-card-title> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="filterDialog = false">
            Close
          </v-btn>
          <v-btn
            color="#147452"
            class="white--text"
            @click="
              initialize();
              filterDialog = false;
            "
          >
            Apply Filter
          </v-btn>
        </v-card-actions>
      </v-card></v-dialog
    >

    <v-dialog fullscreen scrollable persistent v-model="JobPostPrint">
      <v-card>
        <v-card-title dark class="dialog-header">
          <span>Type of Report</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="JobPostPrint = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="PrintFormref">
            <v-row class="mt-4">
              <v-col cols="4">
                <v-autocomplete
                  label="Position"
                  v-model="toPrint"
                  :rules="[formRules.required]"
                  dense
                  class="rounded-lg"
                  item-text="type"
                  item-value="id"
                  color="#93CB5B"
                  :items="reportTypeList"
                >
                </v-autocomplete>
              </v-col>
              <!-- <v-col cols="4">
                  <v-autocomplete
                    label="Item No."
                    v-model="jobitem"
                    :rules="[formRules.required]"
                    @change="handleAllChanges"
                    dense
                    class="rounded-lg"
                    item-text="type"
                    item-value="id"
                    color="#93CB5B"
                    :items="jobitemsList"
                    :disabled="toPrint == 'All' ? true : false"
                  >
                  </v-autocomplete>
                </v-col>
  
                <v-col cols="3">
                  <v-autocomplete
                    label="Month"
                    v-model="selectedMonth"
                    @change="handleAllChanges"
                    dense
                    class="rounded-lg"
                    item-text="name"
                    item-value="id"
                    color="#93CB5B"
                    :items="monthsList"
                    :disabled="
                      jobitem == 'All' ? true : toPrint == 'All' ? true : false
                    "
                  >
                  </v-autocomplete>
                </v-col> -->
              <v-col cols="1">
                <v-autocomplete
                  label="Year"
                  v-model="selectedYear"
                  :rules="[formRules.required]"
                  dense
                  class="rounded-lg"
                  color="#93CB5B"
                  :items="yearList"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-card-title>
              <!-- <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field> -->
            </v-card-title>
            <v-data-table :headers="headers3" :items="printData">
              <template v-slot:[`item.birth`]="{ item }">
                {{ formatDate(item.birth) }}
              </template>
            </v-data-table>
          </v-form>
        </v-card-text>

        <v-card-actions class="pa-5">
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="JobPostPrint = false">
            <v-icon>mdi-close-circle-outline</v-icon>
            Cancel
          </v-btn>
          <!-- <v-btn color="#519043" class="white--text" @click="printApplicants()">
              <v-icon class="mr-1">mdi-printer</v-icon>
              Print
            </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
      :timeout="5000"
    ></fade-away-message-component>
  </div>
</template>
<script>
export default {
  components: {
    // CoreTimeDesignationDialog: () =>
    //   import("../../components/Dialogs/Forms/CoreTimeDesignationDialog.vue"),
    ApplicantOfJobDialog: () =>
      import(
        "../../components/Dialogs/Views/ShortListedJobApplicantDialog.vue"
      ),
  },
  data: () => ({
    search: "",
    fullname: null,
    date_from: null,
    date_to: null,
    applicantData: null,
    menu: false,
    filterDialog: false,
    menu1: false,
    headers: [
      {
        text: "Position Title",
        value: "position_title",
        align: "start",
        valign: "center",
      },

      {
        text: "Plantilla Item No.",
        value: "plantilla_item",
        align: "center",
        valign: "center",
        sortable: false,
      },

      {
        text: "Salary/Job/Pay Grade",
        value: "salary_grade",
        align: "center",
        valign: "center",
        sortable: false,
      },

      {
        text: "Basic Monthly Salary",
        value: "monthly_salary",
        align: "center",
        valign: "center",
        sortable: false,
      },
      {
        text: "Education",
        value: "education",
        align: "center",
        valign: "center",
        sortable: false,
      },
      {
        text: "Training",
        value: "training",
        align: "center",
        valign: "center",
        sortable: false,
      },

      {
        text: "Experiece",
        value: "experience",
        align: "center",
        valign: "center",
        sortable: false,
      },
      {
        text: "Eligibility",
        value: "eligibility",
        align: "center",
        valign: "center",
        sortable: false,
      },
      {
        text: "Competency",
        value: "competency",
        align: "center",
        valign: "center",
        sortable: false,
      },
      {
        text: "Place of Assignment",
        value: "place_assignment",
        align: "center",
        valign: "center",
        sortable: false,
      },
      {
        text: "Action",
        value: "action",
        align: "center",
        valign: "center",
        sortable: false,
      },
    ],

    headers1: [
      {
        text: "Name",
        value: "fullname",
        align: "start",
        valign: "center",
      },
      {
        text: "Email",
        value: "ja_email",
        align: "center",
        valign: "center",
        sortable: false,
      },
      {
        text: "Birth Date",
        value: "ja_birth",
        align: "center",
        valign: "center",
        sortable: false,
      },
      {
        text: "Age",
        value: "age",
        align: "center",
        valign: "center",
        sortable: false,
      },
      {
        text: "Position Applied",
        value: "positionsApplied",
        align: "center",
        valign: "center",
        sortable: false,
        width: 300,
      },

      // {
      //   text: "Action",
      //   value: "action",
      //   align: "center",
      //   valign: "center",
      //   sortable: false,
      // },
    ],
    headers3: [
      {
        text: "Fullname",
        value: "fullname",
        align: "start",
        valign: "center",
      },
      {
        text: "Position",
        value: "position",
        align: "center",
        valign: "center",
        sortable: false,
      },

      {
        text: "Email",
        value: "email",
        align: "center",
        valign: "center",
        sortable: false,
      },
      {
        text: "Phone no.",
        value: "phone_number",
        align: "center",
        valign: "center",
        sortable: false,
      },
      {
        text: "Gender",
        value: "gender",
        align: "center",
        valign: "center",
        sortable: false,
      },
      {
        text: "Birth Date",
        value: "birth",
        align: "center",
        valign: "center",
        sortable: false,
      },
      {
        text: "Address",
        value: "address",
        align: "center",
        valign: "center",
        sortable: false,
      },

      {
        text: "Religion",
        value: "relegion",
        align: "center",
        valign: "center",
        sortable: false,
      },
    ],
    data: [],
    printData: [],
    verified: [],
    perPageChoices: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "20", value: 20 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "250", value: 250 },
      { text: "500", value: 500 },
    ],
    activeTab: { id: 1, name: "Applicants" },
    tab: 1,
    tabList: [
      { id: 1, name: "Applicants" },
      { id: 2, name: "List of Jobs Posted" },
      //   { id: 3, name: "Applicants" },
    ],
    coreTimeData: null,
    totalCount: 0,
    deleteData: null,
    updateData: null,
    loading: false,
    options: {},
    action: null,
    toPrint: null,
    reportTypeList: [],
    jobitem: null,
    jobitemsList: [],
    selectedYear: null,
    selectedMonth: null,
    paginationData: {},
    formdata: [],
    work_dates_menu: false,
    confirmDialog: false,
    JobPostPrint: false,
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Deleted!",
      message: "",
      top: 10,
    },
    yearList: [],
    monthsList: [
      { id: 0, name: "All" },
      { id: 1, name: "January" },
      { id: 2, name: "February" },
      { id: 3, name: "March" },
      { id: 4, name: "April" },
      { id: 5, name: "May" },
      { id: 6, name: "June" },
      { id: 7, name: "July" },
      { id: 8, name: "August" },
      { id: 9, name: "September" },
      { id: 10, name: "October" },
      { id: 11, name: "November" },
      { id: 12, name: "December" },
    ],
  }),

  mounted() {
    this.loadYear();
    // this.eventHub.$on("closeMyJobApplicationDialog", () => {
    //   this.initialize();
    // });
    this.eventHub.$on("closeJobPostinDialog", () => {
      this.initialize();
    });
    this.eventHub.$on("closeApplicantJobList", () => {
      this.initialize();
    });
    this.eventHub.$on("closeMyJobApplicationDialog", () => {
      this.initialize();
    });
    // this.eventHub.$on("closeMyDesignationDialog", () => {
    //   this.initialize();
    // });
  },

  beforeDestroy() {
    // this.eventHub.$off("closeMyJobApplicationDialog");
    this.eventHub.$off("closeJobPostinDialog");
    this.eventHub.$off("closeApplicantJobList");
    this.eventHub.$off("closeMyJobApplicationDialog");

    // this.eventHub.$off("closeMyDesignationDialog");
  },

  watch: {
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    filterYear: {
      handler(newData, oldData) {
        if (oldData != newData) {
          this.initialize();
        }
      },
      deep: true,
    },
  },
  computed: {
    filterYear() {
      return this.$store.getters.getFilterSelected;
    },

    // filterPrintData() {
    //   return this.paginate(
    //     this.data.filter((data) =>
    //       data.employee.toLowerCase().match(this.search.toLowerCase())
    //     )
    //   );
    // },
  },
  methods: {
    clearDateFilter() {
      this.date_from = null;
      this.date_to = null;
      this.initialize();
    },
    hasHtmlTags(str) {
      const htmlRegex = /<[^>]+>/;
      return htmlRegex.test(str);
    },
    loadYear() {
      let curYear;
      var d = new Date();
      curYear = d.getFullYear();
      for (let i = curYear; i >= 2020; i--) {
        this.yearList.push(i);
      }
    },

    pagination(data) {
      this.paginationData = data;
    },

    initialize() {
      this.loading = true;
      let user = this.$store.state.user;
      let filter = this.$store.getters.getFilterSelected;
      console.log("user", user);
      if (this.tab == 1) {
        this.axiosCall(
          "/job-applicant/findAllShortListedApplicant/" +
            filter +
            "/?date_from=" +
            this.date_from +
            "&date_to=" +
            this.date_to,
          "GET",
        ).then((res) => {
          if (res) {
            console.log(res.data);
            this.data = res.data;
            this.loading = false;
          }
        });
      } else if (this.tab == 2) {
        this.axiosCall(
          "/short-list/getTaggedJobPosted/" + filter + "/" + user.id,
          "GET",
        ).then((res) => {
          if (res) {
            this.data = res.data;
            this.loading = false;
          }
        });
      }
    },

    // getVerifiedUsers() {
    //   this.loading = true;

    //   this.axiosCall("/user-details/getAllVerifiedUser", "GET").then((res) => {
    //     if (res) {
    //       this.data = [];

    //       this.data = res.data;
    //       this.loading = false;
    //     }
    //   });
    // },

    changeTab(tab) {
      this.activeTab = tab;
      this.tab = tab.id;
      this.initialize();
    },

    viewApplicant(item) {
      this.applicantData = item;
      this.action = 1;
    },

    printShortListedData() {
      let filter = this.$store.getters.getFilterSelected;
      let url =
        process.env.VUE_APP_SERVER +
        "/pdf-generator/generateJobApplicantsAppliedPosition/" +
        filter +
        "?dateFrom=" +
        this.date_from +
        "&dateTo=" +
        this.date_to;

      let token = localStorage.getItem("token");
      const tab = window.open("about:blank");
      // this.isLoading = true;
      fetch(url, { headers: { Authorization: `Bearer ${token}` } })
        .then((response) => response.blob())
        .then((blob) => {
          var _url = window.URL.createObjectURL(blob);

          tab.location = _url;
          tab.focus();
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.positions-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 6px 0;
}

.position-chip {
  justify-content: flex-start;
  font-weight: 500;
}

.position-date {
  margin-left: 8px;
  padding-left: 8px;
  border-left: 3px solid rgba(0, 0, 0, 0.12);
  font-weight: 400;
  font-size: 0.75rem;
  opacity: 0.85;
}
</style>
